import AppCardSliderLayout from './AppCardSliderLayout.vue';

export default AppCardSliderLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardSliderLayout/index.ts